var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagAuDe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Flag_of_Germany_and_Austria",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.4,
    height: 30,
    viewBox: "0 0 45.4 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_121",
    width: 45.373,
    height: 29.741,
    transform: "translate(0.027)",
    fill: "#d81e05"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_127",
    d: "M0,0H45.4V9.471H15.133Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    d: "M914.207,600H900v9.472h28.414Z",
    transform: "translate(-900 -589.736)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_129",
    d: "M0,1200H14.586v9.471Z",
    transform: "translate(30.814 -1179.471)",
    fill: "#ffce00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagAuDe);
export default __webpack_public_path__ + "static/media/flag_au_de.42ee35fc2ef519be6075bd83dd83b094.svg";
export { ForwardRef as ReactComponent };